/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Anthropic_TitleInputs */

const en_admin_settings_groups_anthropic_title = /** @type {(inputs: Admin_Settings_Groups_Anthropic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic`)
};

const zh_admin_settings_groups_anthropic_title = /** @type {(inputs: Admin_Settings_Groups_Anthropic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic`)
};

/**
* | output |
* | --- |
* | "Anthropic" |
*
* @param {Admin_Settings_Groups_Anthropic_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_anthropic_title = /** @type {((inputs?: Admin_Settings_Groups_Anthropic_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Anthropic_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_anthropic_title(inputs)
	return zh_admin_settings_groups_anthropic_title(inputs)
});
export { admin_settings_groups_anthropic_title as "admin.settings.groups.anthropic.title" }